window.imprimirConteudoModal = function () {
    // Pega o conteúdo do modal
    const conteudo = document.getElementById(
        "modalImprimirOportunidadeConteudo"
    ).innerHTML;

    // Pega todos os estilos CSS da página atual
    const estilos = Array.from(
        document.querySelectorAll('link[rel="stylesheet"], style')
    )
        .map((el) => el.outerHTML)
        .join("\n");

    // Abre uma nova aba
    const novaAba = window.open("", "_blank");

    // Adiciona o HTML com todos os estilos da página atual
    novaAba.document.write(`
        <html>
        <head>
            <title>Impressão - Oportunidade</title>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            ${estilos}
            <style>
                body { 
                    margin: 20px;
                    background: white !important;
                }
                .print-actions {
                    position: fixed;
                    top: 20px;
                    right: 20px;
                    z-index: 1000;
                    background: #007bff;
                    padding: 10px 15px;
                    border-radius: 5px;
                    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
                }
                .print-actions button {
                    background: white;
                    border: none;
                    padding: 8px 15px;
                    border-radius: 3px;
                    margin: 0 5px;
                    cursor: pointer;
                    font-weight: bold;
                }
                .print-actions button:hover {
                    background: #f8f9fa;
                }
                @media print {
                    body { margin: 0; }
                    .no-print, .print-actions { display: none !important; }
                    .modal-body { 
                        background: white !important;
                        padding: 20px !important;
                    }
                }
            </style>
        </head>
        <body>
            <div class="print-actions no-print">
                <button onclick="window.print()">🖨️ Imprimir</button>
                <button onclick="window.close()">❌ Fechar</button>
            </div>
            <div class="container-fluid">
                ${conteudo}
            </div>
        </body>
        </html>
    `);

    // Fecha o documento e foca na nova aba
    novaAba.document.close();
    novaAba.focus();

    novaAba.onload = () => {
        setTimeout(() => novaAba.print(), 500);
    };
};
